<template>
  <page-view
    title="Live Video Shopping"
    icon="shopping-music"
    :class="featuresEnabled.includes('ppv') && (featuresEnabled.includes('lvs') && lvsEditorAccessable) ? 'subpage' : ''"
    :largeMaxWidth="true"
    :contentLoading="!done"
    :backLink="featuresEnabled.includes('ppv') && (featuresEnabled.includes('lvs') && lvsEditorAccessable) ? '/appearance' : ''"
    :backText="featuresEnabled.includes('ppv') && (featuresEnabled.includes('lvs') && lvsEditorAccessable) ? 'Back to Appearance ': ''"
  >
  <div class="d-f fd-c fd-md-r f-g">
    <template v-if="done">
      <div class="f-3">
      <card-minimal :title="$t('settings.liveshopping.general_settings')" :key="`rk${resetKey}general`">
        <div class="d-f f-wrap">
          <div class="p-a-4 f-1-25 settings">
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.overlay') }} {{ $t('settings.liveshopping.color') }} / {{ $t('settings.liveshopping.opacity') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="" :value="colors.main.backdrop" @color="colors.main.backdrop = $event" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.modal') }} {{ $t('settings.liveshopping.background') }} / {{ $t('settings.liveshopping.border_radius') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.main.background" @color="colors.main.background = $event" :noalpha="true" />
                <FormInput class="smallish center-text" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="parseInt(colors.main['border-radius'], 10)" @input="colors.main['border-radius'] = `${$event}px`" fixedPlaceholder="px" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.default') }} {{ $t('settings.liveshopping.font_family') }} <!--/ {{ $t('settings.liveshopping.font_color') }}--></h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormInput class="smallish ml-a" :value="colors.main['font-family']" @input="colors.main['font-family'] = `${$event}`" />
                <!--<FormColorInput class="" :value="colors.main.box.color" @color="colors.main.box.color = $event" :noalpha="true" />-->
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.header') }} {{ $t('settings.liveshopping.font_color') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.title.color" @color="colors.title.color = $event" :noalpha="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.header') }} {{ $t('settings.liveshopping.font_size') }} / {{ $t('settings.liveshopping.weight') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormInput class="smallish f-1 center-text" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="parseInt(colors.title.size, 10)" @input="colors.title.size = `${$event}px`" fixedPlaceholder="px" />
                <FormInput class="smallish f-1 center-text" :stepper="true" type="number" :step="100" :min="100" :max="900" :value="parseInt(colors.title.weight, 10)" @input="colors.title.weight = `${$event}`" />
              </div>
            </div>
          </div>
          <div class="preview general-preview f-1">
            <div class="general-backdrop" :style="`background-color: ${colors.main.backdrop};`">
              <div class="general-modal" :style="`background-color: ${colors.main.background}; border-radius: ${colors.main['border-radius']}`">
                <p class="general-title" :style="`font-size: ${colors.title.size}; font-weight: ${colors.title.weight}; line-height: ${colors.title.height}; color: ${colors.title.color};`">{{ $t('settings.liveshopping.title_text') }}</p>
                <div class="general-box" :style="`background-color: white; color: black; box-shadow: ${colors.main.box['box-shadow']}; border-radius: ${colors.main.box['border-radius']};`">
                  <p>I am a text</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </card-minimal>
      <!--
      <card-minimal title="Landscape" class="m-t-4" :key="`rk${resetKey}landscape`">
        <div class="d-f f-wrap">
          <div class="p-a-4 f-1-25 landscape">
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Sidebar background / blur</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.landscape.sidebar.background" @color="colors.landscape.sidebar.background = $event" :hideAlpha="true" />
                <FormInput class="smallish f-1" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="parseInt(colors.landscape.sidebar.blur, 10)" @input="colors.landscape.sidebar.blur = `${$event}px`" fixedPlaceholder="px" />
              </div>
            </div>
          </div>
          <div class="preview buttons-preview f-1">
            <div :style="`flex: 1; width: 50%; align-self: flex-end; background-color: ${colors.landscape.sidebar.background}; backdrop-filter: blur(${colors.landscape.sidebar.blur});`">
            </div>
          </div>
        </div>
      </card-minimal>
      -->
      <card-minimal :title="$t('settings.liveshopping.buttons')" class="m-t-4" :key="`rk${resetKey}buttons`">
        <div class="d-f f-wrap">
          <div class="p-a-4 f-1-25 buttons">
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.font_size') }} / {{ $t('settings.liveshopping.weight') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormInput class="smallish f-1 center-text" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="parseInt(colors.button.size, 10)" @input="colors.button.size = `${$event}px`" fixedPlaceholder="px" />
                <FormInput class="smallish f-1 center-text" :stepper="true" type="number" :step="100" :min="100" :max="900" :value="parseInt(colors.button.weight, 10)" @input="colors.button.weight = `${$event}`" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.border_radius') }} / {{ $t('settings.liveshopping.uppercase') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormInput class="smallish center-text" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="parseInt(colors.button['border-radius'], 10)" @input="colors.button['border-radius'] = `${$event}px`" fixedPlaceholder="px" />
                <FormCheckbox class="ml-a-i mr-a" :selected="colors.button['text-transform'] === 'uppercase'" icon="check" @input="colors.button['text-transform'] = colors.button['text-transform'] === 'none' ? 'uppercase' : 'none';" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.primary') }} {{ $t('settings.liveshopping.background') }} / text {{ $t('settings.liveshopping.color') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.primary.button.background" @color="colors.primary.button.background = $event" :noalpha="true" />
                <FormColorInput class="" :value="colors.primary.button.color" @color="colors.primary.button.color = $event" :noalpha="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.secondary') }} {{ $t('settings.liveshopping.background') }} / {{ $t('settings.liveshopping.text_color') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.secondary.button.background" @color="colors.secondary.button.background = $event" :noalpha="true" />
                <FormColorInput class="" :value="colors.secondary.button.color" @color="colors.secondary.button.color = $event" :noalpha="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.checkout_button') }} {{ $t('settings.liveshopping.background') }} / {{ $t('settings.liveshopping.text_color') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.cart.checkout.background" @color="colors.cart.checkout.background = $event" :noalpha="true" />
                <FormColorInput class="" :value="colors.cart.checkout.color" @color="colors.cart.checkout.color = $event" :noalpha="true" />
              </div>
            </div>
          </div>
          <div class="preview buttons-preview f-1">
            <button class="buttons-primary-button" :style="`font-size: ${colors.button.size}; text-transform: ${colors.button['text-transform']}; font-weight: ${colors.button.weight}; border-radius: ${colors.button['border-radius']}; color: ${colors.primary.button.color}; background-color: ${colors.primary.button.background};`" :key="`atc${stringsKeyTwo}1`">{{ lvspConfig.strings.en['add_to_cart'] || 'Add to cart' }}</button>
            <button class="buttons-primary-button" :style="`font-size: ${colors.button.size}; text-transform: ${colors.button['text-transform']}; font-weight: ${colors.button.weight}; border-radius: ${colors.button['border-radius']}; color: ${colors.secondary.button.color}; background-color: ${colors.secondary.button.background};`" :key="`atc${stringsKeyTwo}2`">{{ lvspConfig.strings.en['show_in_video'] || 'Show in video' }}</button>
            <button class="buttons-primary-button" :style="`font-size: ${colors.button.size}; color: ${colors.cart.checkout.color}; background-color: ${colors.cart.checkout.background};`" :key="`atc${stringsKeyTwo}3`">{{ lvspConfig.strings.en['checkout_button'] || 'Go to checkout' }}</button>
          </div>
        </div>
      </card-minimal>
      <card-minimal :title="$t('settings.liveshopping.product')" class="m-t-4" :key="`rk${resetKey}product`">
        <div class="d-f f-wrap">
          <div class="p-a-4 f-1-25 product">
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>List products as grid</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormCheckbox class="ml-a-i" :selected="products.grid.enable" icon="check" @input="products.grid.enable = !products.grid.enable;" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Thumbnail price overlay</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormDropdown
                  class="ml-a-i"
                  :items="thumbnailPriceOverlay"
                  :value="products.product_overlay.price_position"
                  placeholder="Select price position"
                  @input="products.product_overlay.price_position = $event.value"
                />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>List image padding</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormInput class="smallish center-text ml-a-i" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="parseInt(colors.product['listimage-padding'], 10)" @input="colors.product['listimage-padding'] = `${$event}px`" fixedPlaceholder="px" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Product image padding / max height (0 = auto)</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormInput class="smallish f-1 center-text" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="parseInt(colors.product['image-padding'], 10)" @input="colors.product['image-padding'] = `${$event}px`" fixedPlaceholder="px" />
                <FormInput class="smallish f-1 center-text" :stepper="true" type="number" :step="1" :min="0" :value="colors.product['image-maxsize'] === 'auto' ? 0 : parseInt(colors.product['image-maxsize'], 10)" @input="$event === '0' || $event === 0 ? colors.product['image-maxsize'] = 'auto' : colors.product['image-maxsize'] = `${$event}px`" fixedPlaceholder="px" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.letter_spacing') }} / {{ $t('settings.liveshopping.weight') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormInput class="smallish f-1 center-text" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="parseInt(colors.product['letter-spacing'], 10)" @input="colors.product['letter-spacing'] = `${$event}px`" fixedPlaceholder="px" />
                <FormInput class="smallish f-1 center-text" :stepper="true" type="number" :step="100" :min="100" :max="900" :value="parseInt(colors.product.weight, 10)" @input="colors.product.weight = `${$event}`" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.font_family') }} / {{ $t('settings.liveshopping.uppercase') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormInput class="smallish" :value="colors.product['font-family']" @input="colors.product['font-family'] = `${$event}`" />
                <FormCheckbox class="ml-a-i mr-a" :selected="colors.product['text-transform'] === 'uppercase'" icon="check" @input="colors.product['text-transform'] = colors.product['text-transform'] === 'none' ? 'uppercase' : 'none';" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.price') }} {{ $t('settings.liveshopping.color') }} / Sales price color</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="mr-a" :value="colors.product.price.color" @color="colors.product.price.color = $event" :noalpha="true" />
                <FormColorInput class="mr-a" :value="colors.product.sales.price.color" @color="colors.product.sales.price.color = $event" :noalpha="true" />
              </div>
            </div>
          </div>
          <div class="preview product-preview f-1">
            <div class="p-a-4 d-f fd-c" :style="`background-color: ${colors.main.background};`">
              <div :style="`background-color: white; color: black;`" :class="`m-b-4 ${products.grid.enable ? 'show-as-grid' : ''}`">
                <div class="d-f ai-c">
                  <div :style="`padding: ${colors.product['listimage-padding']} 0 ${colors.product['listimage-padding']} ${colors.product['listimage-padding']}`">
                    <div style="background-color: gray; height: 50px; width: 50px"></div>
                  </div>
                  <div style="padding-left: 12px;">
                    <h2 class="product-preview-title product-preview-title--list" :style="`color: ${colors.main.box.color}; font-family: ${colors.product['font-family']}; font-weight: ${colors.product.weight}; text-transform: ${colors.product['text-transform']}; letter-spacing: ${colors.product['letter-spacing']};`">My awesome product</h2>
                    <p class="product-preview-price product-preview-price--list" :style="`font-family: ${colors.product['font-family']}; font-weight: ${colors.product.weight}; color: ${colors.product.price.color}; letter-spacing: ${colors.product['letter-spacing']};`">495 kr</p>
                  </div>
                </div>
                <div class="d-f ai-c">
                  <div :style="`padding: ${colors.product['listimage-padding']} 0 ${colors.product['listimage-padding']} ${colors.product['listimage-padding']}`">
                    <div style="background-color: gray; height: 50px; width: 50px"></div>
                  </div>
                  <div style="padding-left: 12px;">
                    <h2 class="product-preview-title product-preview-title--list" :style="`color: ${colors.main.box.color}; font-family: ${colors.product['font-family']}; font-weight: ${colors.product.weight}; text-transform: ${colors.product['text-transform']}; letter-spacing: ${colors.product['letter-spacing']};`">My awesome product</h2>
                    <p class="product-preview-price product-preview-price--list" :style="`font-family: ${colors.product['font-family']}; font-weight: ${colors.product.weight}; color: ${colors.product.price.color}; letter-spacing: ${colors.product['letter-spacing']};`">495 kr</p>
                  </div>
                </div>
                <div class="d-f ai-c">
                  <div :style="`padding: ${colors.product['listimage-padding']} 0 ${colors.product['listimage-padding']} ${colors.product['listimage-padding']}`">
                    <div style="background-color: gray; height: 50px; width: 50px"></div>
                  </div>
                  <div style="padding-left: 12px;">
                    <h2 class="product-preview-title product-preview-title--list" :style="`color: ${colors.main.box.color}; font-family: ${colors.product['font-family']}; font-weight: ${colors.product.weight}; text-transform: ${colors.product['text-transform']}; letter-spacing: ${colors.product['letter-spacing']};`">My awesome product</h2>
                    <p class="product-preview-price product-preview-price--list" :style="`font-family: ${colors.product['font-family']}; font-weight: ${colors.product.weight}; color: ${colors.product.price.color}; letter-spacing: ${colors.product['letter-spacing']};`">495 kr</p>
                  </div>
                </div>
              </div>

              <div class="product-preview-product" :style="`background-color: white; color: black;`">
                <div :style="`padding: ${colors.product['image-padding']} ${colors.product['image-padding']} 0px;`">
                  <div :style="`background-color: gray; ${colors.product['image-maxsize'] !== 'auto' ? `max-height: ${colors.product['image-maxsize']}; height: ${colors.product['image-maxsize']};` : 'padding-top: 100%;'}`"></div>
                </div>
                <div class="p-a-4">
                  <h2 class="product-preview-title" :style="`color: ${colors.main.box.color}; font-family: ${colors.product['font-family']}; font-weight: ${colors.product.weight}; text-transform: ${colors.product['text-transform']}; letter-spacing: ${colors.product['letter-spacing']};`">My awesome product</h2>
                  <p class="product-preview-price" :style="`font-family: ${colors.product['font-family']}; font-weight: ${colors.product.weight}; color: ${colors.product.price.color}; letter-spacing: ${colors.product['letter-spacing']};`">495 kr</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </card-minimal>
      <card-minimal title="Chat" class="m-t-4" :key="`rk${resetKey}chat`">
        <div class="d-f f-wrap">
          <div class="p-a-4 f-1-25 chat">
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.emoji_reaction_symbol') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.default') }} {{ $t('settings.liveshopping.font_size') }} / {{ $t('settings.liveshopping.background') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormInput class="smallish center-text" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="parseInt(colors.chat.size, 10)" @input="colors.chat.size= `${$event}px`" fixedPlaceholder="px" />
                <FormColorInput class="ml-a" :value="colors.chat.background" @color="colors.chat.background = $event" :noalpha="true" :returnRGB="true" />
              </div>
            </div>
            <!--
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.default') }} {{ $t('settings.liveshopping.name') }} / {{ $t('settings.liveshopping.message_color') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.chat['user-color']" @color="colors.chat['user-color'] = $event" :noalpha="true" />
                <FormColorInput class="" :value="colors.chat['text-color']" @color="colors.chat['text-color'] = $event" :noalpha="true" />
              </div>
            </div>
            -->
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Moderator {{ $t('settings.liveshopping.background') }} / {{ $t('settings.liveshopping.text_color') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.chat.moderator.background" @color="colors.chat.moderator.background = $event" :noalpha="true" :returnRGB="true" />
                <FormColorInput class="" :value="colors.chat.moderator.color" @color="colors.chat.moderator.color = $event" :noalpha="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Welcome {{ $t('settings.liveshopping.background') }} / {{ $t('settings.liveshopping.text_color') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.chat.welcome.background" @color="colors.chat.welcome.background = $event" :hideAlpha="true" />
                <FormColorInput class="" :value="colors.chat.welcome.color" @color="colors.chat.welcome.color = $event" :hideAlpha="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.sticky') }} {{ $t('settings.liveshopping.background') }} / {{ $t('settings.liveshopping.text_color') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.chat.pinned.background" @color="colors.chat.pinned.background = $event" :noalpha="true" />
                <FormColorInput class="" :value="colors.chat.pinned.color" @color="colors.chat.pinned.color = $event" :noalpha="true" />
              </div>
            </div>
            <!--
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>{{ $t('settings.liveshopping.border_radius') }}</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormInput class="smallish" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="parseInt(colors.chat['border-radius'], 10)" @input="colors.chat['border-radius'] = `${$event}px`" fixedPlaceholder="px" />
              </div>
            </div>
            -->
          </div>
          <div class="preview chat-preview f-1">
            <div class="d-f ai-c jc-c fd-c">
              <button class="chat-hadiraja-button">
                <div class="emoji-wrapper">
                  <EmojiPicker @emoji="chooseEmoji" class="emoji-picker" :search="emojiSearch" :emojiTable="emojiList">
                    <div slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" :key="`e${emojiKey}`" @click.stop="clickEvent">
                      {{ emojis[0] }}
                    </div>
                    <div slot="emoji-picker" slot-scope="{ emojis, insert }" class="emoji-modal">
                      <div class="emoji-search">
                        <FormInput :value="emojiSearch" @input="emojiSearch = $event" class="f-w m-b-4" :placeholder="$t('common.search')" />
                      </div>
                      <div v-for="(emojiGroup, category) in emojis" :key="category">
                        <h5>{{ category }}</h5>
                        <div class="row">
                          <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji);" :title="emojiName">{{ emoji }}</span>
                        </div>
                      </div>
                    </div>
                  </EmojiPicker>
                </div>
              </button>
              <small style="color: black;">{{ $t('settings.liveshopping.click_me_to_change_me') }}!</small>
            </div>
            <div class="button-group">
              <Button @click="chatPreviewType = 'mobile'" :disabled="chatPreviewType === 'mobile'" class="small">{{ $t('settings.liveshopping.mobile') }}</Button>
              <Button @click="chatPreviewType = 'desktop'" :disabled="chatPreviewType === 'desktop'" class="small">{{ $t('settings.liveshopping.desktop') }}</Button>
            </div>
            <template v-if="chatPreviewType === 'desktop'">
              <div class="general-box" :style="`background-color: ${colors.main.box.background}; box-shadow: ${colors.main.box['box-shadow']}; border-radius: ${colors.main.box['border-radius']};`">
                <div class="chat-message" :style="`font-size: ${colors.chat.size};`">
                  <span :style="`color: ${colors.chat['user-color']};`">{{ $t('settings.liveshopping.name') }}: </span>
                  <span :style="`color: ${colors.chat['text-color']};`">{{ $t('settings.liveshopping.message_text_here') }}</span>
                </div>
                <div class="chat-message" :style="`font-size: ${colors.chat.size};`">
                  <span :style="`background-color: rgba(${colors.chat.moderator.background}, 1); color: ${colors.chat.moderator.color}; padding: 2px;`">{{ $t('settings.liveshopping.name') }}:</span>&nbsp;
                  <span :style="`color: ${colors.chat['text-color']};`">{{ $t('settings.liveshopping.message_text_here') }}</span>
                </div>
                <div class="sticky-message" :style="`font-size: ${colors.chat.size}; color: ${colors.chat.pinned.color}; background-color: ${colors.chat.pinned.background};`">{{ $t('settings.liveshopping.sticky_message') }}!</div>
              </div>
            </template>
            <template v-else>
              <div class="chat-message" :style="`font-size: ${colors.chat.size}; background-color: rgba(${colors.chat.background}, 0.6);`">
                <span :style="`color: ${colors.chat['user-color']};`">{{ $t('settings.liveshopping.name') }}: </span>
                <span :style="`color: ${colors.chat['text-color']};`">{{ $t('settings.liveshopping.message_text_here') }}</span>
              </div>
              <div class="chat-message" :style="`font-size: ${colors.chat.size}; background-color: rgba(${colors.chat.moderator.background}, 0.6); color: ${colors.chat.moderator.color};`">{{ $t('settings.liveshopping.name') }}: {{ $t('settings.liveshopping.message_text_here') }}</div>
              <div class="sticky-message" :style="`font-size: ${colors.chat.size}; color: ${colors.chat.pinned.color}; background-color: ${colors.chat.pinned.background};`">{{ $t('settings.liveshopping.sticky_message') }}</div>
            </template>
          </div>
        </div>
      </card-minimal>
      <card-minimal title="Poster" class="m-t-4" :key="`rk${resetKey}poster`">
        <div class="d-f f-wrap">
          <div class="p-a-4 f-1-25 poster">
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Show Play button</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormCheckbox class="ml-a-i" :selected="poster.play_button.enable" icon="check" @input="poster.play_button.enable = !poster.play_button.enable;" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Show Information / Add to Calendar icon</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormCheckbox class="ml-a-i ml-a" :selected="poster.description.enable" icon="check" @input="poster.description.enable = !poster.description.enable;" />
                <FormCheckbox class="ml-a-i" :selected="poster.calendar.enable" icon="check" @input="poster.calendar.enable = !poster.calendar.enable;" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Base backplate background</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.poster.base.background" @color="colors.poster.base.background = $event" :hideAlpha="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Title backplate background / text color</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.poster.title.background" @color="colors.poster.title.background = $event" :hideAlpha="true" />
                <FormColorInput class="ml-a" :value="colors.poster.title.color" @color="colors.poster.title.color = $event" :noalpha="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Playbutton background / icon color</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.poster.playbutton.background" @color="colors.poster.playbutton.background = $event" :hideAlpha="true" />
                <FormColorInput class="ml-a" :value="colors.poster.playbutton.color" @color="colors.poster.playbutton.color = $event" :hideAlpha="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Playbutton shadow- / hovercolor </h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.poster.playbutton.shadow.color" @color="colors.poster.playbutton.shadow.color = $event" :noalpha="true" :returnRGB="true" />
                <FormColorInput class="ml-a" :value="colors.poster.playbutton.shadow.hovercolor" @color="colors.poster.playbutton.shadow.hovercolor = $event" :noalpha="true" :returnRGB="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Upcoming/Recorded badge background / text color</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.poster.badge.background" @color="colors.poster.badge.background = $event" :hideAlpha="true" />
                <FormColorInput class="ml-a" :value="colors.poster.badge.color" @color="colors.poster.badge.color = $event" :hideAlpha="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Live badge background / text color</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.poster.livebadge.background" @color="colors.poster.livebadge.background = $event" :hideAlpha="true" />
                <FormColorInput class="ml-a" :value="colors.poster.livebadge.color" @color="colors.poster.livebadge.color = $event" :hideAlpha="true" />
              </div>
            </div>
            <div class="d-f theme-row p-t-4 p-b-2 p-x-2 ai-c">
              <div class="theme-row-col p-b-2">
                <h2>Date text color</h2>
              </div>
              <div class="theme-row-col p-b-2">
                <FormColorInput class="ml-a" :value="colors.poster.date.color" @color="colors.poster.date.color = $event" :hideAlpha="true" />
              </div>
            </div>
          </div>
          <div class="preview poster-preview f-1 p-a-4">
            <div class="videoplayer-poster" :style="`min-height: 300px; padding-top: calc((100% * 9) / 16); background-color: ${colors.poster.base.background}; position: relative;`">
              <div class="videoplayer-poster-badge" style="position: absolute; left: 10px; top: 10px; display: flex; align-items: flex-start;">
                <div class="videoplayer-poster-badge-badge videoplayer-poster-badge-badge-live" :style="`background-color: ${colors.poster.livebadge.background}; color: ${colors.poster.livebadge.color};`">
                  <div :style="`background-color: ${colors.poster.livebadge.color};`"></div>
                  <span>Live</span>
                </div>
                <div class="videoplayer-poster-badge-badge" :style="`margin-left: 5px; background-color: ${colors.poster.badge.background}; color: ${colors.poster.badge.color};`">Upcoming / Recorded</div>
              </div>
              <div class="videoplayer-poster-date" :style="`color: ${colors.poster.date.color}; position: absolute; right: 10px; top: 10px; font-weight: 500; text-transform: uppercase;`">
                Today
              </div>
              <div class="videoplayer-poster-playbutton" v-if="poster.play_button.enable" :style="`background-color: ${colors.poster.playbutton.background}; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); border-radius: 100%; width: 96px; height: 96px; display: flex; align-items: center; justify-content: center;`">
                <i class="icon-play" :style="`font-size: 48px; color: ${colors.poster.playbutton.color};`" />
              </div>
              <div class="videoplayer-poster-info" :style="`backdrop-filter: blur(8px); background-color: ${colors.poster.title.background}; padding: 16px; position: absolute; bottom: 0; left: 0; right: 0; display: flex; align-items: center;`">
                <h1 :style="`font-size: 14px; line-height: 16px; padding: 0 20px 0 0; font-weight: 400; color: ${colors.poster.title.color}`">En titel</h1>
                <div class="videoplayer-poster-buttons" style="margin-left: auto; display: flex;">
                  <div v-if="poster.description.enable" class="videoplayer-poster-button" :style="`color: ${colors.primary.button.color}; background-color: ${colors.primary.button.background}; font-size: 20px; height: 38px; width: 38px; display: flex; align-items: center; justify-content: center; border-radius: 100%;`">
                    <i class="icon-information-24" />
                  </div>
                  <div  v-if="poster.calendar.enable" class="videoplayer-poster-button" :style="`margin-left: 8px; color: ${colors.primary.button.color}; background-color: ${colors.primary.button.background}; font-size: 20px; height: 38px; width: 38px; display: flex; align-items: center; justify-content: center; border-radius: 100%;`">
                    <i class="icon-calendar-24" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </card-minimal>
      </div>
      <div class="f-1">
        <card-minimal-title title="Logo" />
        <MediaUpload @images="setImage($event)" :chessboard="true" :multiple="false" title="Logo" :overwrite="true" size="h/50" :data="{ force: true, images: logoImage }" />
      </div>
    </template>
  </div>
    <div class="d-f ai-c">
      <Button @click="save()" :disabled="state === 'saving'" :class="`very-blue ${state === 'saved' ? 'success' : ''}`" :icon="state === 'saving' ? 'loading mdi-spin' : ''">
        <template v-if="state === 'saving'">{{ $t('settings.liveshopping.saving') }}</template>
        <template v-else-if="state === 'saved'">{{ $t('settings.liveshopping.saved') }}</template>
        <template v-else>{{ $t('settings.liveshopping.save') }}</template>
      </Button>
      <a href="" @click.prevent="resetColors()" class="link blue m-l-2">
        {{ $t('settings.liveshopping.reset_colors') }}
      </a>
    </div>
  </page-view>
</template>

<script>
import EmojiPicker from 'vue-emoji-picker';
import MediaUpload from '@/components/MediaUpload.vue';
import emojiList from '@/assets/emojilist.json';

const merge = require('deepmerge');

export default {
  components: {
    EmojiPicker,
    MediaUpload,
  },
  computed: {
    thumbnailPriceOverlay() {
      return [
        { value: 'bottom-right', string: 'Bottom right', selected: this.products.product_overlay.price_position === 'bottom-right' },
        { value: 'top-right', string: 'Top right', selected: this.products.product_overlay.price_position === 'top-right' },
        { value: 'below', string: 'Below image', selected: this.products.product_overlay.price_position === 'below' },
      ];
    },
    /**
     * Return boolean if lvs editor is accessable
     * @returns {Boolean}
     */
    lvsEditorAccessable() {
      const trialEnded = this.$store.getters['AccountManager/trialEnded'];
      const subscriptionEnded = this.$store.getters['AccountManager/subscriptionEnded'];

      if (trialEnded || subscriptionEnded) {
        return false;
      }

      return this.accountSettings?.shopping?.permissions?.appearance;
    },
    /**
     * Returns a boolean if the account as a external products provider or not
     * @returns {Boolean}
     */
    isShopify() {
      const { shoppingSettings: { provider } = {} } = this;
      return provider.includes('shopify');
    },
    /**
     * Return the current config in store
     * @returns {Object}
     */
    lvspConfig() {
      return this.$store.getters['Play/lvspConfig'];
    },
  },
  methods: {
    /**
     * Set emoji
     * @param {String} emoji
     */
    chooseEmoji(emoji) {
      this.emojis[0] = emoji;
      this.emojiKey += 1;
    },
    /**
     * Set logo
     * @param {Object} param0
     * @param {Array} param0.arr
     */
    setImage(arr) {
      if (arr.length === 0) {
        this.logoImage = [];
      } else {
        this.logoImage = [arr[0].value];
      }
    },
    /**
     * Reset colors
     */
    resetColors() {
      this.colors = JSON.parse(JSON.stringify(this.defaultColors));
      this.resetKey += 1;
    },
    /**
     * Save theme settings
     */
    async save() {
      const {
        colors,
        logoImage,
        emojis,
        poster,
        products,
      } = this;

      const payload = {
        appearance: colors,
        emojis,
        poster,
        products,
        images: {
          logo: logoImage.length > 0 ? logoImage[0] : '',
        },
      };

      this.state = 'saving';
      const result = await this.$store.dispatch('Play/updateLVSPConfig', payload);

      if (result.error) {
        swal({ title: this.$t('errors.error_occured'), text: this.$t('settings.liveshopping.could_not_save'), icon: 'error' });
        this.state = '';
        return;
      }

      this.state = 'saved';

      setTimeout(() => {
        this.state = '';
      }, 1500);
    },
  },
  watch: {
    colors: {
      deep: true,
      immediate: true,
      handler(c) {
        if (c?.poster) {
          document.querySelector('body').style.setProperty('--sf-poster-playbutton-shadow-color', c.poster.playbutton.shadow.color);
          document.querySelector('body').style.setProperty('--sf-poster-playbutton-shadow-hovercolor', c.poster.playbutton.shadow.hovercolor);
          document.querySelector('body').style.setProperty('--sf-poster-livebadge-color', c.poster.livebadge.color);
        }
      },
    },
  },
  data() {
    return {
      chatPreviewType: 'mobile',
      // eslint-disable-next-line
      emojiList: emojiList,
      state: '',
      done: false,
      emojiKey: 0,
      resetKey: 0,
      stringsKey: 0,
      stringsKeyTwo: 0,
      emojis: ['👍'],
      logoImage: [],
      colors: {},
      poster: {
        calendar: {
          enable: false,
        },
        play_button: {
          enable: false,
        },
        sharing: {
          enable: false,
        },
        description: {
          enable: false,
        },
      },
      products: {
        grid: {
          enable: false,
        },
        product_overlay: {
          price_position: 'bottom-right',
        },
      },
      defaultColors: {
        main: {
          backdrop: '#00000080',
          background: '#FFFFFF',
          'border-radius': '8px',
          'font-family': '"Inter", sans-serif',
          box: {
            background: '#FFFFFF',
            color: '#000000',
            'border-radius': '0px',
            'box-shadow': '0 2px 6px 0 rgb(0 0 0 / 10%)',
          },
        },
        poster: {
          base: {
            background: '#212121FF',
          },
          title: {
            background: '#ffffff99',
            color: '#000000',
          },
          playbutton: {
            background: '#ffffffff',
            color: '#0060FF',
            shadow: {
              color: '0, 0, 0',
              hovercolor: '255, 255, 255',
            },
          },
          livebadge: {
            background: '#e80000FF',
            color: '#FFFFFFFF',
          },
          badge: {
            background: '#00000099',
            color: '#FFFFFFFF',
          },
          date: {
            color: '#FFFFFFFF',
          },
        },
        landscape: {
          sidebar: {
            background: '#ffffffa0',
            blur: '10px',
          },
        },
        title: {
          color: '#4D4D4D',
          size: '13px',
          weight: 500,
          height: '20px',
        },
        button: {
          'border-radius': '0px',
          size: '14px',
          weight: 500,
          'text-transform': 'none',
        },
        product: {
          'font-family': '"Inter", sans-serif', // pris ärver
          'letter-spacing': '0px', // pris ärver
          'image-padding': '8px',
          'listimage-padding': '5px',
          'image-maxsize': '200px',
          weight: 500, // pris ärver
          'text-transform': 'none',
          price: {
            color: '#000000',
          },
          sales: {
            price: {
              color: '#F00D0D',
            },
          },
        },
        primary: {
          button: {
            background: '#0060FF',
            color: '#FFFFFF',
          },
        },
        secondary: {
          button: {
            background: '#FFFFFF',
            color: '#0060FF',
          },
        },
        chat: {
          'user-color': '#000000',
          'text-color': '#000000',
          'border-radius': '4px',
          size: '12px',
          background: '255,255,255',
          moderator: {
            background: '0,0,0',
            color: '#FFFFFF',
          },
          welcome: {
            background: '#FFFFFFFF',
            color: '#000000FF',
          },
          pinned: {
            background: '#B0FFC5',
            color: '#00511D',
          },
        },
        cart: {
          checkout: {
            background: '#26CB6B',
            color: '#FFFFFF',
          },
        },
      },
      emojiSearch: '',
    };
  },
  async mounted() {
    await this.$store.dispatch('Play/getLVSPConfig');

    if (!this.lvsEditorAccessable) {
      this.$router.replace({ path: '/appearance' });
      return;
    }

    const {
      appearance = {},
      images = [],
      emojis,
      poster = {},
      products = {},
    } = this.lvspConfig;

    this.colors = merge(merge(this.colors, this.defaultColors), appearance);
    if (!emojis || emojis.length === 0) {
      this.emojis[0] = '👍';
    } else {
      // eslint-disable-next-line
      this.emojis[0] = emojis[0];
    }
    this.logoImage = [images.logo];
    this.poster = {
      calendar: {
        enable: poster.calendar?.enable,
      },
      play_button: {
        enable: poster.play_button?.enable,
      },
      sharing: {
        enable: poster.sharing?.enable,
      },
      description: {
        enable: poster.description?.enable,
      },
    };
    this.products = {
      grid: {
        enable: products.grid?.enable || false,
      },
      product_overlay: {
        price_position: products.product_overlay?.price_position || 'bottom-right',
      },
    };
    this.done = true;
  },
};
</script>

<style lang="scss">
body, :host {
  --sf-poster-playbutton-shadow-color: 0, 0, 0;
  --sf-poster-playbutton-shadow-hovercolor: 255, 255, 255;
}

button {
  &:focus {
    outline: none !important;
  }
}

.f-1-25 {
  flex: 1.5;
}

.f-1 {
  flex: 1;
}

.settings {
  order: 2;
  min-width: 100%;
}

.preview {
  background-image: linear-gradient(45deg, #EAEAEA 25%, transparent 25%), linear-gradient(-45deg, #EAEAEA 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #EAEAEA 75%), linear-gradient(-45deg, transparent 75%, #EAEAEA 75%);
  background-size: 24px 24px;
  background-position: 0 0, 0 12px, 12px -12px, -12px 0px;
  position: relative;
  min-width: 100%;
  min-height: 200px;
  order: 1;
}

@media (min-width: 1100px) {
  .settings {
    order: 1;
    min-width: auto;
  }

  .preview {
    order: 2;
    min-width: auto;
  }
}

.poster-preview {
  .videoplayer-poster-playbutton {
    box-shadow: 0 2px 4px 0 rgba(var(--sf-poster-playbutton-shadow-color), 0.10), 0 4px 8px 0 rgba(var(--sf-poster-playbutton-shadow-color), 0.10);
    transition: background-color .3s, box-shadow .3s;
  }

  .videoplayer-poster {
    &:hover {
      .videoplayer-poster-playbutton {
        box-shadow: 0 2px 4px 0 rgba(var(--sf-poster-playbutton-shadow-color), 0.10), 0 4px 8px 0 rgba(var(--sf-poster-playbutton-shadow-color), 0.10), 0 0 0 6px rgba(var(--sf-poster-playbutton-shadow-hovercolor), 0.46);
      }
    }
  }

  .videoplayer-poster-badge-badge {
    border-radius: 16px;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;
    display: inline-block;
  }

  .videoplayer-poster-badge-badge-live {
    display: flex;
    align-items: center;

    & > div {
      width: 12px;
      height: 12px;
      background-color: var(--sf-poster-livebadge-color);
      display: inline-block;
      border-radius: 50%;
      box-shadow: 0 0 0 0 var(--sf-poster-livebadge-color);
      transform: scale(1);
      animation: pulse 1s infinite;
      margin-right: 5px;
      margin-top: -1px;
    }
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--sf-poster-livebadge-color);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.chat-preview {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  .chat-hadiraja-button {
    border-radius: 100%;
    background: #FFFFFF;
    display: flex;
    font-size: 24px;
    align-items: center;
    justify-content: center;
    line-height: 1;
    height: 48px;
    width: 48px;
    box-shadow: 0 0 1px 0 rgba(0,0,0,0.15), 0 1px 2px 0 rgba(0,0,0,0.15);
    cursor: pointer;
  }

  .chat-message, .sticky-message {
    padding: 5px 40px;
    border-radius: 24px;
    line-height: 1;
  }

  .general-box {
    width: 60%;
    padding: 5px;
    .chat-message, .sticky-message {
      padding: 5px;
      border-radius: 0;
      margin-top: 5px;
      &:first-child {
        margin-top: 0;
      }
    }
  }
}

.emoji-wrapper {
  position: relative;
  .emoji-search {
    width: 100%;

    input {
      max-width: 100%;
      font-size: 14px;
    }
  }

  .emoji-picker {
    position: relative;

    button {
      background-color: #DAEBFF;
      font-size: 12px;
      padding: 5px 10px;
      border-radius: 5px;
    }

    .emoji-modal {
      max-height: 300px;
      min-width: 250px;
      max-width: 250px;
      width: 100%;
      overflow: auto;
      position: absolute;
      left: 50%;
      top: 0;
      z-index: 10;
      padding: 16px;
      background-color: #FAFBFC;
      border-radius: 10px;
      box-shadow: 0 6px 12px 0 rgba(0,0,0,0.04), 0 2px 4px 0 rgba(0,0,0,0.04);
      transform: translateX(-50%) translateY(-105%);

      h5 {
        font-size: 14px;
      }

      span {
        cursor: pointer;
        font-size: 24px;
        line-height: 24px;
        padding: 5px;
      }

      .row {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
}

.buttons-preview {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  .buttons-primary-button {
    color: white;
    background: #0060FF;
    border-radius: 4px;
    padding: 10px 16px;
    line-height: 1;
    width: 60%;
  }
  .buttons-secondary-button {
    border-radius: 100%;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    height: 48px;
    width: 48px;
    box-shadow: 0 0 1px 0 rgba(0,0,0,0.15), 0 1px 2px 0 rgba(0,0,0,0.15);
  }
}

.product-preview {
  display: flex;
  background-image: none;

  .show-as-grid {
    display: grid;
    grid-template: repeat(2, 1fr) / repeat(2, 1fr);
    grid-gap: 6px;
    padding: 5px;

    & > * {
      flex-direction: column;
      padding: 0;
      text-align: center;

      & > * {
        &:first-child {
          background-color: gray;
          width: 100%;
          padding: 0 !important;
          padding-top: 100% !important;
          & > * {
            display: none;
            height: auto !important;
            padding-top: 100%;
            width: 100% !important;
            aspect-ratio: 1;

            &::before{
                content: "";
                display: block;
                padding-top: 100%;
            }
          }
        }
      }
    }
  }

  & > div {
    flex: 1;
    display: flex;
  }

  .product-preview-product {
    align-self: stretch;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    flex: 1;
    background: #FFFFFF;
    text-align: center;
    justify-self: center;

    .product-preview-title {
      font-size: 20px;
      line-height: 24px;

      &.product-preview-title--list {
        font-size: 14px;
        line-height: 18px;
      }
    }
    .product-preview-price {
      font-size: 16px;
      line-height: 24px;
      text-transform: uppercase;

      &.product-preview-price--list {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
}

.general-preview {
  display: flex;
  .general-backdrop {
    display: flex;
    flex: 1;
    padding: 20px;
  }
  .general-modal {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 16px 16px;
  }
  .general-title {
    text-transform: uppercase;
    text-align: center;
    padding: 16px 0 8px;
  }
  .general-box {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.theme-row {
  border-bottom: 1px solid #E8EBEE;
  flex-wrap: wrap;

  h2 {
    font-size: 16px;
    &::first-letter {
      text-transform:capitalize;
    }
  }

  .color-input .color {
    max-width: 120px;
  }

  .input {
    max-width: 120px;
    width: 100%;
  }

  .theme-row-col {
    display: flex;
    min-width: 250px;

    & > * {
      &:last-child:not(:only-child) {
        margin-left: 10px;
      }
    }

    &:last-child {
      margin-left: auto;
    }
  }

  &:last-child {
    border-bottom: 0;
  }
}

.cp-box {
  position: relative;

  .vc-chrome {
    position: absolute;
    right: 50%;
    top: 80%;
    z-index: 1;
  }
}

.url {
  border-bottom: 1px solid #e0e0e0;

  header {
    position: relative;
    padding-right: 25px;

    i {
      cursor: pointer;
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &:last-child {
    border-bottom: 0;
  }

  .dropdown-row {
    .dropdown {
      border-radius: 0;
      float: left;
      width: 50%;

      .inner {
        border-radius: 0;
      }

      &:first-child {
        border-radius: 5px 0 0 0;
        .inner {
          border-radius: 5px 0 0 0;
        }
      }

      &:last-child {
        border-radius: 0 5px 0 0;
        .inner {
          border-radius: 0 5px 0 0;
        }
      }
    }
  }

  .tui-editor-defaultUI {
    border-radius: 0 0 5px 5px;
    border-top: 0;

    .te-toolbar-section {
      display: none;
    }
  }

  .url-row {
    &.no-borders {
      .input {
        border-radius: 0;
        border-top: 0;
        border-bottom: 0;
      }

      .input-wrapper {
        border-radius: 0;
      }

      .input-inner {
        border-radius: 0;
      }

      input {
        border-radius: 0;
      }
    }

    &.no-top-borders {
      .input {
        border-radius: 0 0 5px 5px;
        border-top: 0;
      }

      .input-wrapper {
        border-radius: 0 0 5px 5px;
      }

      .input-inner {
        border-radius: 0 0 4px 4px;
      }

      input {
        border-radius: 0;
      }
    }
  }
}
</style>
